/* CsakCsajok arany termékoldal (sections/cc-gold.liquid) – 2026-10-22
   galéria, görgetésre feltűnés, görgetős történet, ragadós kosársáv, liquid glass mutatókövetés, kosárba tétel (AJAX → kosároldal) */
(function () {
  document.querySelectorAll('.ccg').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(.23,1,.32,1)';

    // galéria: bélyegkép, nyíl, húzás (jobbra-balra), körbeér
    var stage = root.querySelector('.gx-stage .im');
    var gImgs = stage ? stage.querySelectorAll('img') : [];
    var thumbs = root.querySelectorAll('.gx-thumbs button');
    var gCur = 0;
    function show(i, dir, fromX) {
      var n = gImgs.length;
      i = (i + n) % n;
      if (i === gCur || !n) return;
      var out = gImgs[gCur], inn = gImgs[i];
      dir = dir || (i > gCur ? 1 : -1);
      gCur = i;
      inn.removeAttribute('loading');
      inn.hidden = false;
      out.hidden = true;
      thumbs.forEach(function (x, j) { x.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (still || !inn.animate) return;
      var w = stage.offsetWidth * 0.3;
      out.animate([{ opacity: 1, transform: 'translateX(' + (fromX || 0) + 'px)' }, { opacity: 0, transform: 'translateX(' + (-dir * w) + 'px) scale(.96)' }], { duration: 220, easing: EASE });
      inn.animate([{ opacity: 0, transform: 'translateX(' + (dir * w) + 'px) scale(.96)' }, { opacity: 1, transform: 'none' }], { duration: 340, easing: EASE });
    }
    if (stage && gImgs.length > 1) {
      stage.classList.add('is-js');
      thumbs.forEach(function (b) { b.addEventListener('click', function () { show(+b.dataset.i); }); });
      root.querySelectorAll('[data-ccg-nav]').forEach(function (b) {
        b.addEventListener('click', function () { var d = +b.dataset.ccgNav; show(gCur + d, d); });
      });
      // húzás: a kép követi az ujjat; elég a távolság (60 px) vagy egy gyors pöccintés
      var sx = 0, sy = 0, st = 0, dx = 0, drag = false, axis = '';
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (drag) return;
        drag = true; axis = ''; sx = e.clientX; sy = e.clientY; st = Date.now(); dx = 0;
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag) return;
        var mx = e.clientX - sx, my = e.clientY - sy;
        if (!axis) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
          axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
          // érintésnél a böngésző már magától elkapja az ujjat; egérnél kérjük mi
          if (axis === 'x' && e.pointerType === 'mouse') { try { stage.setPointerCapture(e.pointerId); } catch (er) {} }
        }
        if (axis !== 'x') return;
        dx = mx;
        gImgs[gCur].style.transform = 'translateX(' + (dx * 0.6).toFixed(1) + 'px)';
      });
      function end() {
        if (!drag) return;
        drag = false;
        var img = gImgs[gCur];
        if (axis !== 'x') return;
        var v = Math.abs(dx) / Math.max(1, Date.now() - st);
        var from = dx * 0.6;
        img.style.transform = '';
        if (Math.abs(dx) > 60 || v > 0.11) {
          var d = dx < 0 ? 1 : -1;
          show(gCur + d, d, from);
        } else if (img.animate && !still) {
          img.animate([{ transform: 'translateX(' + from + 'px)' }, { transform: 'none' }], { duration: 200, easing: EASE });
        }
      }
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
    }

    // rácsokban lépcsőzetes beúszás
    root.querySelectorAll('.gx-mat, .gx-calm-grid').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--d', (i * 0.09).toFixed(2) + 's'); });
    });

    // számláló: a számmal kezdődő nagy szám nulláról pörög fel
    function count(el) {
      if (el.dataset.done) return;
      el.dataset.done = '1';
      var m = /^(\d+)(.*)$/.exec(el.textContent.trim());
      if (!m || still) return;
      var to = +m[1], rest = m[2], t0 = null;
      function f(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / 1400);
        el.textContent = Math.round(to * (1 - Math.pow(1 - k, 4))) + rest;
        if (k < 1) requestAnimationFrame(f);
      }
      el.textContent = '0' + rest;
      requestAnimationFrame(f);
    }

    // görgetésre feltűnés
    var els = root.querySelectorAll('.rv');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { threshold: 0.15 });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('is-in'); });

    // görgetés: hős kép hátralép, a történetben a kép forog/vált, a fejezetek beúsznak és elhalványulnak
    var hero = root.querySelector('[data-ccg-hero]');
    var story = root.querySelector('[data-ccg-story]');
    if (!still && (hero || story)) {
      var steps = story ? story.querySelectorAll('.gx-step') : [];
      var cards = story ? story.querySelectorAll('.gx-step-in') : [];
      var imgs = story ? story.querySelectorAll('.gx-story-stage img') : [];
      var dots = story ? story.querySelectorAll('.gx-story-rail li') : [];
      var storyStage = story && story.querySelector('.gx-story-stage');
      var glow = story && story.querySelector('.gx-story-glow');
      var wrapSteps = story && story.querySelector('.gx-story-steps');
      var desk = innerWidth >= 960, offs = [];
      var cur = -1, ticking = false;
      // a kártyák nyugalmi helyzete (transform nélkül) – átméretezéskor újramérjük
      function measure() {
        desk = innerWidth >= 960;
        offs = Array.prototype.map.call(cards, function (c) { return c.offsetTop + c.offsetHeight / 2; });
      }
      if (story && steps.length) {
        story.classList.add('is-pin');
        imgs.forEach(function (im) { im.removeAttribute('loading'); });
      }
      function setActive(i) {
        if (i === cur) return;
        cur = i;
        imgs.forEach(function (im, j) { im.classList.toggle('on', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('on', j === i); d.classList.toggle('done', j < i); });
        steps.forEach(function (st, j) { if (j === i) st.classList.add('is-on'); });
        var c = steps[i] && steps[i].querySelector('[data-ccg-count]');
        if (c) count(c);
      }
      function frame() {
        ticking = false;
        var vh = innerHeight;
        if (hero) {
          var hr = hero.getBoundingClientRect();
          var hp = Math.max(0, Math.min(1, -hr.top / (hr.height || 1)));
          hero.style.transform = 'translate3d(0,' + (hp * -36).toFixed(1) + 'px,0) scale(' + (1 - hp * 0.07).toFixed(4) + ')';
          hero.style.opacity = (1 - hp * 0.55).toFixed(3);
        }
        if (!story || !steps.length) return;
        var r = story.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - vh)));
        var s = Math.sin(p * Math.PI);
        // először a mérés, utána csak írás (nincs layout-csapkodás); a transformot közvetlenül írjuk, nem CSS-változón át
        var top0 = wrapSteps.getBoundingClientRect().top;
        storyStage.style.transform = 'translate(-50%,-50%) translateY(' + (p * -4).toFixed(2) + 'svh) rotate(' + (-9 + p * 18).toFixed(2) + 'deg) scale(' + (0.9 + s * 0.14).toFixed(4) + ')';
        glow.style.transform = 'scale(' + (0.85 + s * 0.25).toFixed(4) + ')';
        glow.style.opacity = (0.55 + s * 0.45).toFixed(3);
        // a fejezet ott a legélesebb, ahol nyugalomban állna (mobilon lent, asztalon középen)
        var focus = vh * (desk ? 0.5 : 0.62), best = 0, bestD = 1e9;
        cards.forEach(function (c, i) {
          var d = (top0 + offs[i] - focus) / (vh * 0.55);
          var a = Math.abs(d);
          var f = Math.max(0, Math.min(1, 1.35 - a * a * 1.6));
          c.style.opacity = f.toFixed(3);
          c.style.transform = 'translate3d(0,' + (d * 36).toFixed(1) + 'px,0) scale(' + (0.94 + f * 0.06).toFixed(4) + ')';
          if (a < bestD) { bestD = a; best = i; }
        });
        setActive(best);
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', function () { if (story && steps.length) measure(); onScroll(); }, { passive: true });
      if (story && steps.length) measure();
      frame();
    } else if (story) {
      story.querySelectorAll('.gx-step').forEach(function (st) { st.classList.add('is-in'); });
      story.querySelectorAll('[data-ccg-count]').forEach(function (c) { c.dataset.done = '1'; });
    }

    // ragadós kosársáv: akkor jön elő, ha a fő gombok már fent vannak a képernyőn kívül
    var bar = root.querySelector('[data-ccg-bar]'), cta = root.querySelector('.gx-cta');
    if (bar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var en = es[0];
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var btn = bar.querySelector('button');
        if (btn) btn.tabIndex = on ? 0 : -1;
      }).observe(cta);
    }

    // kosárba: AJAX, majd a kosároldal; hiba esetén üzenet, JS nélkül a sima űrlap megy
    var form = root.querySelector('[data-ccg-form]');
    var err = root.querySelector('[data-ccg-err]');
    function add() {
      var btn = form.querySelector('[data-ccg-add]');
      if (btn.disabled) return;
      btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Hiba');
          if (navigator.vibrate) try { navigator.vibrate(10); } catch (e) {}
          location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        });
      }).catch(function (e) {
        btn.disabled = false;
        if (err) { err.hidden = false; err.textContent = /already|már/i.test(e.message) ? 'Ez a darab már a kosaradban van.' : 'Most nem sikerült kosárba tenni. Próbáld újra, vagy írj nekünk.'; }
      });
    }
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
      var barAdd = root.querySelector('[data-ccg-bar-add]');
      if (barAdd) barAdd.addEventListener('click', add);
    }

    // liquid glass: a fényfolt követi az egeret
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.addEventListener('pointermove', function (e) {
        var el = e.target.closest && e.target.closest('.lg');
        if (!el) return;
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
      root.addEventListener('pointerout', function (e) {
        var el = e.target.closest && e.target.closest('.lg');
        if (el && !el.contains(e.relatedTarget)) { el.style.removeProperty('--mx'); el.style.removeProperty('--my'); }
      });
    }
  });
})();
